import type {BioIconProps} from '../../icons/common-types'

export default function TheMobileInsiderLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <circle cx="14.5" cy="14.8164" r="14.5" fill="white" fillOpacity="0.28" />
        <rect x="6.5" y="0.5" width="17" height="29" rx="3.5" stroke="white" />
      </svg>
      <span>The Mobile Insider</span>
    </div>
  )
}
